import * as marietta from '../..';
import MonicaObject from './MonicaObject';
import { SVGSprite } from '../flash/display';
import { ITEM_MODE_NAME_ENG } from '../Constants';

export default class Shitae extends MonicaObject {
    imgView: Element;

    defaultItemInfo: marietta.webcad.collection.ItemInfoCollection;

    constructor(_itemInfo: marietta.webcad.collection.ItemInfoCollection) {
      super(_itemInfo);

      this.defaultItemInfo = new marietta.webcad.collection.ItemInfoCollection();
      this.defaultItemInfo = Object.assign(this.defaultItemInfo, _itemInfo);
    }

    /**
     * リドロー
     */
    reCreateImage=() => {
      this.spt.remove();

      // 再作成
      this.createImage();
    }

    /**
     * ビューの作成
     */
    createImage() {
      let viewObj: Element;
      if (this.spt === undefined || this.spt === null) {
        viewObj = document.createElementNS('http://www.w3.org/2000/svg', 'g');
        viewObj.setAttribute('id', `${this.itemInfo.id}_${this.itemInfo.guid}`);
      } else {
        viewObj = this.spt.element;
      }

      // イメージ
      this.imgView = document.createElementNS('http://www.w3.org/2000/svg', 'image');
      this.imgView.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', this.itemInfo.imgSrc);
      this.imgView.setAttribute('opacity', '0.5');
      this.imgView.setAttribute('pointer-events', 'none');
      // this.imgView.setAttribute('preserveAspectRatio', 'none');
      this.imgView.setAttribute('id', `${this.itemInfo.id}_${this.itemInfo.guid}_img`);
      // this.imgView.setAttribute("d", marietta.webcad.util.SVGUtil.getPathString( this.itemInfo.dotList ) );
      this.imgView.setAttribute('width', String(this.itemInfo.width));
      this.imgView.setAttribute('height', String(this.itemInfo.height));
      viewObj.appendChild(this.imgView);

      this.spt = new SVGSprite(viewObj);
      this.spt.scaleX = 1;
      this.spt.scaleY = 1;

      // 中央原点になるように座標変換
      this.imgView.setAttribute('x', String(-this.itemInfo.width / 2));
      this.imgView.setAttribute('y', String(-this.itemInfo.height / 2));
      this.spt.x = this.itemInfo.x;
      this.spt.y = this.itemInfo.y;
      this.spt.update();

      // クリックイベントを削除
      if (marietta.webcad.WebCADGlobal.userAgentManager.isMobile || marietta.webcad.WebCADGlobal.userAgentManager.isTablet) {
        this.spt.element.removeEventListener('touchstart', this.onMouseDownMe);
      } else {
        this.spt.element.removeEventListener('mousedown', this.onMouseDownMe);
      }

      // 左メニューの表示チェックボックスを変更
      let tarLayer: marietta.webcad.layer.ItemLayer;
      // 左メニューのアルファ値を変更
      (<HTMLInputElement> document.getElementById('checkShitaeOpacity')).value = marietta.webcad.WebCADGlobal.SHITAE_OPACITY.toString();
      this.changeOpactiy(marietta.webcad.WebCADGlobal.SHITAE_OPACITY / 100);
      // 既存の表示とアルファに反映
      for (let i = 1; i <= 3; i += 1) {
        tarLayer = marietta.webcad.WebCADGlobal.layerGroup.getTargetLayer(ITEM_MODE_NAME_ENG.MODE_SHITAE_NAME_ENG, i, true) as marietta.webcad.layer.ItemLayer;
        if ((tarLayer as marietta.webcad.layer.ShitaeLayer).childList.length !== 0) {
          (tarLayer as marietta.webcad.layer.ShitaeLayer).changeOpactiy(marietta.webcad.WebCADGlobal.SHITAE_OPACITY);
          (tarLayer as marietta.webcad.layer.ShitaeLayer).changeImageVisible(true);
        }
      }
    }

    /**
     * 表示
     */
    show() {
      this.spt.show();
    }

    /**
     * 非表示
     */
    hide() {
      this.spt.hide();
    }

    /**
     * 透過度を変更
     */
    changeOpactiy(num: number) {
      this.spt.alpha = num;
    }
}
